export const GET_PRODUCTS_PENDING = 'GET_PRODUCTS_PENDING';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR';

export function getProductsPending() {
  return { type: GET_PRODUCTS_PENDING }
};

export function getProductsSuccess(payload) {
  return { type: GET_PRODUCTS_SUCCESS, payload }
};

export function getProductsError(error) {
  return { type: GET_PRODUCTS_ERROR, error }
};
